import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-900 pb-28 pt-12 text-center text-brand-100/70 md:pb-16" data-id="element-151" data-mp="19j53j40hsmi0">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-152" data-mp="20715qw8apju8">
        <p className="font-display text-[11px] font-bold uppercase tracking-[0.42em] text-brand-400" data-id="element-153" data-mp="2f5d5jbqyt8pm">
          Dr. Karito
        </p>
        <p className="mt-3 font-display text-lg font-black uppercase tracking-wide text-white sm:text-xl" data-id="element-154" data-mp="2a71rspxjue24">
          Aligner Case Commander™
        </p>
        <p className="mt-2 text-[13px] font-medium" data-id="element-155" data-mp="1hhbdogvx3c60">
          Visual case organization system for aligner workflows
        </p>

        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-brand-100/50" data-id="element-156" data-mp="1w70t9h4rbipt">
          This product is educational and organizational material. It does not replace professional
          education, diagnosis, clinical judgment, manufacturer instructions, or applicable laws and
          regulations. Individual clinical decisions and patient care remain the responsibility of the
          treating professional.
        </p>

        <p className="mt-6 text-[11px] font-semibold text-brand-100/40" data-id="element-157" data-mp="1efzjeos5tyb0">
          © 2026 Dr. Karito. All rights reserved.
        </p>
      </div>
    </footer>;
}